/* eslint-disable */
import { combineReducers } from "redux";
import { connectRouter, RouterState } from "connected-react-router";
import { all, spawn } from "redux-saga/effects";
import { History } from "history";
import { isArray } from "lodash";
import { isNil, includes } from "ramda";

import { SessionState } from "./session/types";
import sessionReducer from "./session/reducer";
import sessionSaga from "./session/sagas";

import { UserState } from "./user/types";
import userReducer from "./user/reducer";
import userSaga from "./user/sagas";

import { ResetMfaState } from "./resetMfa/types";
import resetMfaReducer from "./resetMfa/reducer";
import resetMfaSaga from "./resetMfa/sagas";

import { UserGroupState } from "./usergroup/types";
import userGroupReducer from "./usergroup/reducer";
import userGroupSaga from "./usergroup/sagas";

import { PermissionState } from "./permission/types";
import permissionReducer from "./permission/reducer";
import permissionSaga from "./permission/sagas";


import { MerchantState } from "./merchant/types";
import merchantReducer from "./merchant/reducer";
import merchantSaga from "./merchant/sagas";

import { MerchantStagingState } from "./merchantStaging/types";
import merchantStagingReducer from "./merchantStaging/reducer";
import merchantStagingSaga from "./merchantStaging/sagas";

import { ProcessorState } from "./processor/types";
import processorReducer from "./processor/reducer";
import processorSaga from "./processor/sagas";

import { PosState } from "./pos/types";
import posReducer from "./pos/reducer";
import posSaga from "./pos/sagas";

import { ReceiptState } from "./receipt/types";
import receiptReducer from "./receipt/reducer";
import receiptSaga from "./receipt/sagas";

import { TerminalState } from "./terminal/types";
import terminalReducer from "./terminal/reducer";
import terminalSaga from "./terminal/sagas";

import { LogoState } from "./logo/types";
import logoReducer from "./logo/reducer";
import logoSaga from "./logo/sagas";

import { PosSoftwareState } from "./possoftware/types";
import posSoftwareReducer from "./possoftware/reducer";
import posSoftwareSaga from "./possoftware/sagas";

import { CardState } from "./card/types";
import cardReducer from "./card/reducer";
import cardSaga from "./card/sagas";

import { CardTypeState } from "./cardType/types";
import cardTypeReducer from "./cardType/reducer";
import cardTypeSaga from "./cardType/sagas";

import { CertState } from "./cert/types";
import certReducer from "./cert/reducer";
import certSaga from "./cert/sagas";

import { EmvState } from "./emv/types";
import emvReducer from "./emv/reducer";
import emvSaga from "./emv/sagas";

import { CloseLoopState } from "./closeLoop/types";
import closeLoopReducer from "./closeLoop/reducer";
import closeLoopSaga from "./closeLoop/sagas";

import { OfflinePaymentTypeGroupState } from "./offlinePaymentTypeGroup/types";
import offlinePaymentTypeGroupReducer from "./offlinePaymentTypeGroup/reducer";
import offlinePaymentTypeGroupSaga from "./offlinePaymentTypeGroup/sagas";

import { TokenWalletState } from "./tokenWallet/types";
import TokenWalletReducer from "./tokenWallet/reducer";
import TokenWalletSaga from "./tokenWallet/sagas";

import { MccState } from "./mcc/types";
import mccReducer from "./mcc/reducer";
import mccSaga from "./mcc/sagas";

import { StatsState } from "./stats/types";
import statsReducer from "./stats/reducer";
import statsSaga from "./stats/sagas";

import { WorkspaceState } from "./workspace/types";
import workspaceReducer from "./workspace/workspaceSlice";
import { CardPromptState } from "./cardPrompt/types";
import cardPromptReducer from "./cardPrompt/cardPromptSlice";

import { AuditState } from "./audit/types";
import auditReducer from "./audit/reducer";
import auditSaga from "./audit/sagas";

import { MyAxisState } from "./myAxis/types";
import myAxisReducer from "./myAxis/reducer";
import myAxisSaga from "./myAxis/sagas";

import { CustomGroupState } from "./customGroup/types";
import customGroupReducer from "./customGroup/reducer";
import customGroupSaga from "./customGroup/sagas";

import { HashedHotCardState } from "./hashedHotCard/types";
import hashedHotCardReducer from "./hashedHotCard/reducer";
import HotCardSaga from "./hashedHotCard/sagas";

import { TerminalBackgroundState } from "./terminalBackground/types";
import terminalBackgroundReducer from "./terminalBackground/reducer";
import terminalBackgroundSaga from "./terminalBackground/sagas";
import resetStanSaga from "./resetSTAN/sagas";

// cardswipe
import { BranchState } from "./branch/types";
import branchReducer from "./branch/reducer";
import branchSaga from "./branch/sagas";

import { WorkstationState } from "./workstation/types";
import workstationReducer from "./workstation/reducer";
import workstationSaga from "./workstation/sagas";


export interface ApplicationState {
  router: RouterState;
  session: SessionState;
  user: UserState;
  resetMfa: ResetMfaState;
  userGroup: UserGroupState;
  permission: PermissionState;
  merchant: MerchantState;
  merchantStaging: MerchantStagingState;
  processor: ProcessorState;
  posSoftware: PosSoftwareState;
  pos: PosState;
  receipt: ReceiptState;
  terminal: TerminalState;
  terminalLogos: LogoState;
  card: CardState;
  cardType: CardTypeState;
  cardPrompt: CardPromptState;
  cert: CertState;
  emv: EmvState;
  closeloop: CloseLoopState;
  offlinePaymentTypeGroup: OfflinePaymentTypeGroupState;
  tokenWallet: TokenWalletState;
  mcc: MccState;
  stats: StatsState;
  workspace: WorkspaceState;
  audit: AuditState;
  myAxis: MyAxisState;
  customGroup: CustomGroupState;
  terminalBackground: TerminalBackgroundState;
  branch: BranchState;
  workstation: WorkstationState;
  hashedHotCard: HashedHotCardState;
}

export const createRootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    session: sessionReducer,
    user: userReducer,
    resetMfa: resetMfaReducer,
    userGroup: userGroupReducer,
    permission: permissionReducer,
    merchant: merchantReducer,
    merchantStaging: merchantStagingReducer,
    processor: processorReducer,
    posSoftware: posSoftwareReducer,
    pos: posReducer,
    receipt: receiptReducer,
    terminal: terminalReducer,
    terminalLogos: logoReducer,
    card: cardReducer,
    cardType: cardTypeReducer,
    cardPrompt: cardPromptReducer,
    cert: certReducer,
    emv: emvReducer,
    closeloop: closeLoopReducer,
    offlinePaymentTypeGroup: offlinePaymentTypeGroupReducer,
    tokenWallet: TokenWalletReducer,
    mcc: mccReducer,
    stats: statsReducer,
    workspace: workspaceReducer,
    audit: auditReducer,
    myAxis: myAxisReducer,
    customGroup: customGroupReducer,
    terminalBackground: terminalBackgroundReducer,
    branch: branchReducer,
    workstation: workstationReducer,
    hashedHotCard: hashedHotCardReducer,
  });

export function* rootSaga() {
  yield all([
    spawn(userSaga),
    spawn(resetMfaSaga),
    spawn(resetStanSaga),
    spawn(sessionSaga),
    spawn(userGroupSaga),
    spawn(permissionSaga),
    spawn(merchantSaga),
    spawn(merchantStagingSaga),
    spawn(processorSaga),
    spawn(posSoftwareSaga),
    spawn(posSaga),
    spawn(receiptSaga),
    spawn(terminalSaga),
    spawn(logoSaga),
    spawn(cardSaga),
    spawn(cardTypeSaga),
    spawn(certSaga),
    spawn(emvSaga),
    spawn(closeLoopSaga),
    spawn(TokenWalletSaga),
    spawn(mccSaga),
    spawn(statsSaga),
    spawn(auditSaga),
    spawn(myAxisSaga),
    spawn(customGroupSaga),
    spawn(terminalBackgroundSaga),
    spawn(branchSaga),
    spawn(workstationSaga),
    spawn(HotCardSaga),
    spawn(offlinePaymentTypeGroupSaga),
  ]);
}

export interface Error {
  code: string;
  title: string;
  detail: string;
}

export const isAuthError = (errors: any): boolean => {
  if (isArray(errors)) {
    return !isNil(
      errors.find((err: Error) =>
        includes(err.code.toUpperCase(), [ "USER-TOKEN", "USER-AUTH", "AUTHENTICATE-FAIL" ])
      )
    );
  }
  return false;
};
